import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createMuiTheme, ThemeProvider, Grid, Typography, Button, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Divider, RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import {
    DateRange as DateRangeIcon,
    QueryBuilder as QueryBuilderIcon,
    RemoveCircle as RemoveCircleIcon,
    AddCircle as AddCircleIcon,
    ExpandMore as ExpandMoreIcon,
    Close as CloseIcon,
    RadioButtonUnchecked as RadioButtonUncheckedIcon,
    CheckCircleOutline as CheckCircleOutlineIcon,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderBar from "../../components/HeaderBar";
import Footer from "../../components/Footer";
import { SERVER_URL } from "../../config/backend";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import fns_format from "date-fns/format";
import { Calendar } from "react-date-range";
import { es as date_range_location } from "react-date-range/dist/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { addYears, addMonths, addDays, setHours, setMinutes, setSeconds, getHours, getMinutes, isAfter, isBefore, isEqual } from "date-fns";
import eachDayOfInterval from "date-fns/eachDayOfInterval";
import isMonday from "date-fns/isMonday";
import isTuesday from "date-fns/isTuesday";
import isWednesday from "date-fns/isWednesday";
import isThursday from "date-fns/isThursday";
import isFriday from "date-fns/isFriday";
import isSaturday from "date-fns/isSaturday";
import isSunday from "date-fns/isSunday";
import { TimePicker } from "@material-ui/pickers";
import ModalMensajes from "../../components/ModalMensajes";
import Loader from "../../components/Loader";
import LoaderCircle from "../../components/LoaderCircle";

const useStyles = makeStyles((theme) => ({
    paperContainer: {
        height: "100%",
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
    },
    gridItem: {
        padding: 0,
        margin: 0,
    },
    typographyTextoReservaAhora: {
        color: "#182C20",
        fontFamily: "Georgia Bold",
        fontSize: "26px",
        marginTop: "3rem",
    },
    tituloReservaSeleccionada: {
        color: "#182C20",
        fontWeight: "bold",
        fontSize: "16px",
        fontFamily: "Verdana",
    },
    tituloReservaSeleccionada2: {
        color: "#F3F3F3",
        fontWeight: "bold",
        fontSize: "16px",
        fontFamily: "Verdana",
    },
    typographyTextoReservaAhoraForm: {
        color: "#A68A30",
        fontFamily: "Georgia Bold",
        fontSize: "26px",
        marginTop: "3rem",
    },
    tituloReservaSeleccionadaForm: {
        color: "#A68A30",
        fontWeight: "bold",
        fontSize: "16px",
        fontFamily: "Verdana",
    },
    textoCardHeader: {
        color: "#F3F3F3",
        [theme.breakpoints.only("xs")]: {
            fontSize: 14,
        },
        [theme.breakpoints.up("sm")]: {
            fontSize: 18,
        },
    },
    textoCardHeaderForm: {
        color: "#A68A30",
        fontWeight: "bold",
        fontStyle: "italic",
        fontSize: 14,
        fontFamily: "Arial",
    },
    textCartaMenu: {
        color: "#F3F3F3",
        fontStyle: "italic",
        marginLeft: "0.2rem",
        fontSize: "13px",
        fontWeight: "bold",
        "&:hover": {
            cursor: "pointer",
        },
    },
    iconTextField: {
        color: theme.palette.secondary.dark,
    },
    iconTextFieldDisabled: {
        color: theme.palette.secondary.contrastText,
    },
    buttomReservar: {
        color: "#FFFFFF",
        fontFamily: "Verdana bold",
        border: "3px solid",
        borderColor: "#F3F3F3",
        borderRadius: "8px",
        fontSize: "12px",
    },
    divider: {
        height: "3px",
        backgroundColor: "#A68A30",
    },
    etiquetaDataFormReserva: {
        color: "#F3F3F3",
        fontSize: "14px",
    },
    numeroDataFormReserva: {
        color: "#A68A30",
        fontFamily: "Verdana Bold",
    },
    precioTotalDataForm: {
        color: "#A68A30",
        fontSize: "14px",
    },
    buttons: {
        width: 150,
        color: "#FFFFFF",
        fontSize: "12px",
        fontFamily: "Verdana Bold",
        borderRadius: 8,
        opacity: "200%",
        background: "linear-gradient(900deg, #F7D00E 30%, #A68A30 90%)",
        paddingTop: 8,
        paddingBottom: 8,
        "&:hover": {
            background: "#DFDFDF",
        },
    },
    dividerData: {
        height: "2px",
        backgroundColor: "#DFDFDF",
        width: "100%",
    },
    radioButton: {
        color: theme.palette.primary.contrastText,
    },
    labelPagosINternacionales: {
        // marginTop: "-2rem",
        color: "#929292",
        fontStyle: "italic",
        [theme.breakpoints.between(0, 399)]: {
            fontSize: 11,
        },
        [theme.breakpoints.between(400, 599)]: {
            fontSize: 16,
        },
        [theme.breakpoints.up("sm")]: {
            fontSize: 16,
        },
    },
    textoButtonPagar: {
        backgroundColor: "#DFDFDF",
        width: "30%",
        borderRadius: "8px",
        fontSize: "12px",
        fontFamily: "Verdana Bold",
        marginBottom: "40px",
    },
    modalContent: {
        backgroundColor: theme.palette.primary.main,
    },
    modalActions: {
        backgroundColor: theme.palette.primary.main,
        paddingBottom: 20,
        paddingTop: 20,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
    iconClose: {
        color: theme.palette.secondary.contrastText,
    },
    textoHeader: {
        color: theme.palette.secondary.dark,
        fontWeight: "bold",
        fontSize: "14pt",
    },
    divider2: {
        height: "8px",
        backgroundColor: theme.palette.secondary.dark,
        width: "15%",
    },
    inputCalendar: {
        "& .rdrDateDisplayWrapper": {
            display: "none",
        },
    },
    inputCalendar2: {
        "& .rdrDateDisplayWrapper": {
            display: "none",
        },
        "& .rdrMonthsVertical": {
            fontSize: 10,
        },
    },
    horarios: {
        textAlign: "center",
        justifyItems: "center",
        alignItems: "center",
        marginBottom: "5px",
        width: "100%",
        color: "#F3F3F3",
        [theme.breakpoints.only("xs")]: {
            fontSize: 14,
        },
        [theme.breakpoints.up("sm")]: {
            fontSize: 16,
        },
    },
    texto2: {
        color: theme.palette.common.white,
    },
    texto3: {
        color: "#A68A30",
        fontStyle: "italic",
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                color: "white",
                borderColor: "#A68A30", // Hover state
                "&:hover $notchedOutline": {
                    borderColor: "#A68A30",
                    border: "2px solid",
                }, // Focused state
                "&$focused $notchedOutline": {
                    borderColor: "#A68A30",
                    border: "2px solid",
                },
            }, // Default State
            notchedOutline: {
                borderColor: "#A68A30",
                border: "2px solid",
            },
        },
    },
});

const theme2 = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                color: "white",
                borderColor: "#182C20", // Hover state
                "&:hover $notchedOutline": {
                    borderColor: "#182C20",
                    border: "2px solid",
                }, // Focused state
                "&$focused $notchedOutline": {
                    borderColor: "#182C20",
                    border: "2px solid",
                },
            }, // Default State
            notchedOutline: {
                borderColor: "#182C20",
                border: "2px solid",
            },
        },
    },
});

export default function Restaurantes(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const intl = useIntl();
    const selector = useSelector((store) => store);
    const globalLang = useSelector((store) => (store.user.lang === undefined ? "es" : store.user.lang));

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [ancho, setAncho] = useState(window.screen.width);
    const [rootPath] = useState({
        inicio: "ruta_navegacion_inicio",
        name: "ruta_navegacion_restaurantes",
        path: "/restaurantes",
    });
    const [openLoader, setOpenLoader] = useState(false);
    const [imagenPrincipal, setImagenPrincipal] = useState(require("../../static/Imágenes/Restaurantes/Image_banner.webp"));
    const [imagenCarrusel1, setImagenCarrusel1] = useState("");
    const [imagenCarrusel2, setImagenCarrusel2] = useState("");
    const [imagenCarrusel3, setImagenCarrusel3] = useState("");
    const [tituloRestaurante, setTituloRestaurante] = useState("NOMBRE DEL RESTAURANTE");
    const [descripcionRestaurante, setDescripcionRestaurante] = useState("DESCRIPCION DEL RESTAURANTE");
    const [openModalFecha, setOpenModalFecha] = useState(false);
    const [openModalHora, setOpenModalHora] = useState(false);
    const [openModalRestaurantes, setOpenModalRestaurantes] = useState(false);
    const [fechaReservacion, setFechaReservacion] = useState(new Date());
    const [horaReservacion, setHoraReservacion] = useState(new Date());
    const [inputPersonas, setInputPersonas] = useState(1);
    const [selectRestaurantes, setSelectRestaurantes] = useState([]);
    const [indexRestaurante, setIndexRestaurante] = useState({ index: 0, nombre: "No hay Restaurantes", reservable: true });
    const [openModalMensajes, setOpenModalMensajes] = useState(false);
    const [cuerpoModalMensajes, setCuerpoModalMensajes] = useState({
        tituloModal: "informacion",
        textoModal: "",
    });
    const [listHorario, setListHorario] = useState([]);
    const [fechaInvalidas, setFechaInvalidas] = useState([]);
    const [rangoHorario, setRangoHorario] = useState([]);
    const [menuRestaurante, setMenuRestaurante] = useState([]);
    const [openNotificacionPago, setOpenNotificacionPago] = useState(false);
    const [estadoReseva, setEstadoReseva] = useState(false);
    const [idReservacion, setIdReservacion] = useState(0);
    const formReservarRestaurante = useRef(null);
    //? work here areyesarean
    const [isPendingRestaurantsQuery, setIsPendingRestaurantsQuery] = useState(true)

    let textoSubtitulo = "subtitulo_restaurante"; //aqui se le pasa el id al header bar
    let textoTitulo = intl.formatMessage({ id: "titutlo_restaurante" }).toString();
    let textoCardHeaderRestaurantes = intl.formatMessage({ id: "restaurante" }).toString();
    let textoHorario = intl.formatMessage({ id: "horario" }).toString();
    let textoCartaMenu = intl.formatMessage({ id: "carta_menu" }).toString();
    // let textoUbicacionHotel = intl.formatMessage({ id: "ubicacion_hotel" }).toString();
    let textoReservaAhora = intl.formatMessage({ id: "reserva_ahora" }).toString();
    let textoDatosReserva = intl.formatMessage({ id: "seleccione_datos_reserva" }).toString();
    let textoPersonas = intl.formatMessage({ id: "personas" }).toString();
    let textoFechaDisfrute = intl.formatMessage({ id: "fecha_disfrute" }).toString();
    let textoHoraDisfrute = intl.formatMessage({ id: "hora_disfrute" }).toString();
    let textoTodosLosDias = intl.formatMessage({ id: "horario1" }).toString();

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------

    const cargarRestaurantes = async () => {
        let queryRestaurantes = `query Restaurantes($skip: Int!, $take: Int!, $report: Boolean!) {
            restaurants(skip: $skip, take: $take, report: $report) {
                status
                errors {
                    field
                    messages
                }
                objects {
                    id
                    name
                    poeticDescription
                    isActive
                    schedule {
                        days {
                            day
                            closed
                            open
                            close
                        }
                    }
                    description
                    order
                    mainImage {
                        url
                    }
                    image1 {
                        url
                    }
                    image2 {
                        url
                    }
                    image3 {
                        url
                    }
                    isReservable
                    menuLetters {
                        id
                        name
                        isActive
                        dishGroups {
                            dishGroup {
                                id
                                name
                                isActive
                            }
                            products {
                                id
                                name
                                nameEn
                                price
                                photo {
                                    name
                                    url
                                }
                                isActive
                            }
                        }
                    }
                }
            }
        }`;

        await fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + selector.user.accessToken,
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                language: globalLang,
            },
            body: JSON.stringify({
                operationName: "Restaurantes",
                query: queryRestaurantes,
                variables: {
                    skip: 1,
                    take: 100,
                    report: true,
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                //? work here areyesarean
                setIsPendingRestaurantsQuery(false)
                if (data["data"]["restaurants"]["status"] === 200) {
                    if (data["data"]["restaurants"]["objects"].length > 0) {
                        let restaurantes_ids = [];
                        let arr_restaurantes = [];
                        for (const iterator of data["data"]["restaurants"]["objects"]) {
                            if (iterator.isActive) {
                                arr_restaurantes.push(iterator);
                                restaurantes_ids.push({ id: iterator.id, name: iterator.name });
                            }
                        }
                        if (arr_restaurantes.length > 0) {
                            setSelectRestaurantes(restaurantes_ids);
                            setIndexRestaurante({
                                ...indexRestaurante,
                                index: arr_restaurantes[0]["id"],
                                nombre: arr_restaurantes[0]["name"],
                                reservable: arr_restaurantes[0]["isReservable"],
                            });
                            let imagenPrincipal = "";
                            let imagenCarrusel1 = "";
                            let imagenCarrusel2 = "";
                            let imagenCarrusel3 = "";
                            if (arr_restaurantes[0]["mainImage"] !== null) {
                                imagenPrincipal = arr_restaurantes[0]["mainImage"]["url"];
                            } else {
                                imagenPrincipal = require("../../static/Imágenes/Restaurantes/Image_banner.webp");
                            }
                            if (arr_restaurantes[0]["image1"] !== null) {
                                imagenCarrusel1 = arr_restaurantes[0]["image1"]["url"];
                            } else {
                                imagenCarrusel1 = "";
                            }
                            if (arr_restaurantes[0]["image2"] !== null) {
                                imagenCarrusel2 = arr_restaurantes[0]["image2"]["url"];
                            } else {
                                imagenCarrusel2 = "";
                            }
                            if (arr_restaurantes[0]["image3"] !== null) {
                                imagenCarrusel3 = arr_restaurantes[0]["image3"]["url"];
                            } else {
                                imagenCarrusel3 = "";
                            }

                            //obteniendo horario del restaurante
                            let arrayHorario = arr_restaurantes[0]["schedule"]["days"];
                            let auxHorario = [];
                            let diasValidos = [];
                            let arrRangoHorario = {};
                            for (let i = 0; i < arrayHorario.length; i++) {
                                if (arrayHorario[i]["open"] !== null) {
                                    auxHorario.push(arrayHorario[i]);
                                    diasValidos.push(arrayHorario[i].day);

                                    //obtener rango de fecha
                                    let hora_inicio = parseInt(arrayHorario[i].open.split(":")[0]);
                                    let aux_minuto_inicio = arrayHorario[i].open.split(":")[1];
                                    let minuto_inicio = parseInt(aux_minuto_inicio.split(" ")[0]);
                                    let meridiano_inicio = aux_minuto_inicio.split(" ")[1];

                                    let hora_final = parseInt(arrayHorario[i].close.split(":")[0]);
                                    let aux_minuto_final = arrayHorario[i].close.split(":")[1];
                                    let minuto_final = parseInt(aux_minuto_final.split(" ")[0]);
                                    let meridiano_final = aux_minuto_final.split(" ")[1];

                                    if (meridiano_inicio === "AM" && hora_inicio === 12) {
                                        hora_inicio = 0;
                                    }
                                    if (meridiano_final === "AM" && hora_final === 12) {
                                        hora_final = 0;
                                    }
                                    if (meridiano_inicio === "PM" && hora_inicio !== 12) {
                                        hora_inicio = hora_inicio + 12;
                                    }
                                    if (meridiano_final === "PM" && hora_final !== 12) {
                                        hora_final = hora_final + 12;
                                    }

                                    let fecha_inicio = setHours(new Date(), hora_inicio);
                                    let fecha_final = setHours(new Date(), hora_final);
                                    fecha_inicio = setMinutes(fecha_inicio, minuto_inicio);
                                    fecha_final = setMinutes(fecha_final, minuto_final);
                                    fecha_inicio = setSeconds(fecha_inicio, 0);
                                    fecha_final = setSeconds(fecha_final, 0);
                                    if (meridiano_inicio === "PM" && meridiano_final === "AM") {
                                        fecha_final = addDays(fecha_final, 1);
                                    }
                                    arrRangoHorario[arrayHorario[i].day] = { inicio: fecha_inicio, final: fecha_final };
                                }
                            }
                            setRangoHorario(arrRangoHorario);
                            let fecha_anno = eachDayOfInterval({ start: new Date(), end: addYears(new Date(), 1) });
                            let fechas_invalidas = [];
                            for (const iterator of fecha_anno) {
                                if (diasValidos.indexOf("Lunes") === -1 && isMonday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                } else if (diasValidos.indexOf("Martes") === -1 && isTuesday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                } else if (diasValidos.indexOf("Miércoles") === -1 && isWednesday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                } else if (diasValidos.indexOf("Jueves") === -1 && isThursday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                } else if (diasValidos.indexOf("Viernes") === -1 && isFriday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                } else if (diasValidos.indexOf("Sábado") === -1 && isSaturday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                } else if (diasValidos.indexOf("Domingo") === -1 && isSunday(iterator)) {
                                    fechas_invalidas.push(iterator);
                                }
                            }
                            setFechaInvalidas(fechas_invalidas);
                            if (auxHorario.length === 7) {
                                let todosdias = true;
                                let open = auxHorario[0].open;
                                let close = auxHorario[0].close;

                                for (const iterator of auxHorario) {
                                    if (open !== iterator.open || close !== iterator.close) {
                                        todosdias = false;
                                        break;
                                    }
                                }
                                if (todosdias === true) {
                                    auxHorario = [
                                        {
                                            day: "Todos los días",
                                            open: open,
                                            close: close,
                                        },
                                    ];
                                }
                            }
                            setListHorario(auxHorario);
                            setImagenPrincipal(imagenPrincipal);
                            setImagenCarrusel1(imagenCarrusel1);
                            setImagenCarrusel2(imagenCarrusel2);
                            setImagenCarrusel3(imagenCarrusel3);
                            setTituloRestaurante(arr_restaurantes[0]["name"]);
                            setDescripcionRestaurante(arr_restaurantes[0]["description"]);
                            setMenuRestaurante(arr_restaurantes[0]["menuLetters"]);
                        } else {
                            setImagenPrincipal(require("../../static/Imágenes/Restaurantes/Image_banner.webp"));
                        }
                    }
                }
            });
    };

    const handleChangeFechaReserva = (e) => {
        setFechaReservacion(e);
        setOpenModalFecha(false);
    };

    const handleChangeHoraReserva = (e) => {
        setHoraReservacion(e);
    };

    const handleChangeRestaurantes = (id) => {
        let queryRestaurantes = `query Restaurantes($id: ID!) {
            restaurantById(id: $id) {
                status
                errors {
                    field
                    messages
                }
                object {
                    id
                    name
                    poeticDescription
                    isActive
                    schedule {
                        days {
                            day
                            closed
                            open
                            close
                        }
                    }
                    description
                    order
                    mainImage {
                        url
                    }
                    image1 {
                        url
                    }
                    image2 {
                        url
                    }
                    image3 {
                        url
                    }
                    isReservable
                    menuLetters {
                        id
                        name
                        isActive
                        dishGroups {
                            dishGroup {
                                id
                                name
                                isActive
                            }
                            products {
                                id
                                name
                                nameEn
                                price
                                photo {
                                    name
                                    url
                                }
                                isActive
                            }
                        }
                    }
                }
            }
        }`;
        setOpenLoader(true);
        fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + selector.user.accessToken,
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                language: globalLang,
            },
            body: JSON.stringify({
                operationName: "Restaurantes",
                query: queryRestaurantes,
                variables: {
                    id: id,
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data["data"]["restaurantById"]["status"] === 200) {
                    setIndexRestaurante({
                        ...indexRestaurante,
                        index: data["data"]["restaurantById"]["object"]["id"],
                        nombre: data["data"]["restaurantById"]["object"]["name"],
                        reservable: data["data"]["restaurantById"]["object"]["isReservable"],
                    });
                    let imagenPrincipal = "";
                    let imagenCarrusel1 = "";
                    let imagenCarrusel2 = "";
                    let imagenCarrusel3 = "";
                    if (data["data"]["restaurantById"]["object"]["mainImage"] !== null) {
                        imagenPrincipal = data["data"]["restaurantById"]["object"]["mainImage"]["url"];
                    } else {
                        imagenPrincipal = require("../../static/Imágenes/Restaurantes/Image_banner.webp");
                    }
                    if (data["data"]["restaurantById"]["object"]["image1"] !== null) {
                        imagenCarrusel1 = data["data"]["restaurantById"]["object"]["image1"]["url"];
                    } else {
                        imagenCarrusel1 = "";
                    }
                    if (data["data"]["restaurantById"]["object"]["image2"] !== null) {
                        imagenCarrusel2 = data["data"]["restaurantById"]["object"]["image2"]["url"];
                    } else {
                        imagenCarrusel2 = "";
                    }
                    if (data["data"]["restaurantById"]["object"]["image3"] !== null) {
                        imagenCarrusel3 = data["data"]["restaurantById"]["object"]["image3"]["url"];
                    } else {
                        imagenCarrusel3 = "";
                    }

                    //obteniendo horario del restaurante
                    let arrayHorario = data["data"]["restaurantById"]["object"]["schedule"]["days"];
                    let auxHorario = [];
                    let diasValidos = [];
                    let arrRangoHorario = {};
                    for (let i = 0; i < arrayHorario.length; i++) {
                        if (arrayHorario[i]["open"] !== null) {
                            auxHorario.push(arrayHorario[i]);
                            diasValidos.push(arrayHorario[i].day);

                            //obtener rango de fecha
                            let hora_inicio = parseInt(arrayHorario[i].open.split(":")[0]);
                            let aux_minuto_inicio = arrayHorario[i].open.split(":")[1];
                            let minuto_inicio = parseInt(aux_minuto_inicio.split(" ")[0]);
                            let meridiano_inicio = aux_minuto_inicio.split(" ")[1];

                            let hora_final = parseInt(arrayHorario[i].close.split(":")[0]);
                            let aux_minuto_final = arrayHorario[i].close.split(":")[1];
                            let minuto_final = parseInt(aux_minuto_final.split(" ")[0]);
                            let meridiano_final = aux_minuto_final.split(" ")[1];

                            if (meridiano_inicio === "AM" && hora_inicio === 12) {
                                hora_inicio = 0;
                            }
                            if (meridiano_final === "AM" && hora_final === 12) {
                                hora_final = 0;
                            }
                            if (meridiano_inicio === "PM" && hora_inicio !== 12) {
                                hora_inicio = hora_inicio + 12;
                            }
                            if (meridiano_final === "PM" && hora_final !== 12) {
                                hora_final = hora_final + 12;
                            }

                            let fecha_inicio = setHours(new Date(), hora_inicio);
                            let fecha_final = setHours(new Date(), hora_final);
                            fecha_inicio = setMinutes(fecha_inicio, minuto_inicio);
                            fecha_final = setMinutes(fecha_final, minuto_final);
                            fecha_inicio = setSeconds(fecha_inicio, 0);
                            fecha_final = setSeconds(fecha_final, 0);
                            if (meridiano_inicio === "PM" && meridiano_final === "AM") {
                                fecha_final = addDays(fecha_final, 1);
                            }
                            arrRangoHorario[arrayHorario[i].day] = { inicio: fecha_inicio, final: fecha_final };
                        }
                    }
                    setRangoHorario(arrRangoHorario);
                    let fecha_anno = eachDayOfInterval({ start: new Date(), end: addYears(new Date(), 1) });
                    let fechas_invalidas = [];
                    for (const iterator of fecha_anno) {
                        if ((diasValidos.indexOf("Lunes") === -1 && diasValidos.indexOf("Monday") === -1) && isMonday(iterator)) {
                            fechas_invalidas.push(iterator);
                        } else if ((diasValidos.indexOf("Martes") === -1 && diasValidos.indexOf("Tuesday") === -1) && isTuesday(iterator)) {
                            fechas_invalidas.push(iterator);
                        } else if ((diasValidos.indexOf("Miércoles") === -1 && diasValidos.indexOf("Wednesday") === -1) && isWednesday(iterator)) {
                            fechas_invalidas.push(iterator);
                        } else if ((diasValidos.indexOf("Jueves") === -1 && diasValidos.indexOf("Thursday") === -1) && isThursday(iterator)) {
                            fechas_invalidas.push(iterator);
                        } else if ((diasValidos.indexOf("Viernes") === -1 && diasValidos.indexOf("Friday") === -1) && isFriday(iterator)) {
                            fechas_invalidas.push(iterator);
                        } else if ((diasValidos.indexOf("Sábado") === -1 && diasValidos.indexOf("Saturday") === -1) && isSaturday(iterator)) {
                            fechas_invalidas.push(iterator);
                        } else if ((diasValidos.indexOf("Domingo") === -1 && diasValidos.indexOf("Sunday") === -1) && isSunday(iterator)) {
                            fechas_invalidas.push(iterator);
                        }
                    }
                    setFechaInvalidas(fechas_invalidas);
                    if (auxHorario.length === 7) {
                        let todosdias = true;
                        let open = auxHorario[0].open;
                        let close = auxHorario[0].close;

                        for (const iterator of auxHorario) {
                            if (open !== iterator.open || close !== iterator.close) {
                                todosdias = false;
                                break;
                            }
                        }
                        if (todosdias === true) {
                            auxHorario = [
                                {
                                    day: textoTodosLosDias,
                                    open: open,
                                    close: close,
                                },
                            ];
                        }
                    }
                    setListHorario(auxHorario);
                    setImagenPrincipal(imagenPrincipal);
                    setImagenCarrusel1(imagenCarrusel1);
                    setImagenCarrusel2(imagenCarrusel2);
                    setImagenCarrusel3(imagenCarrusel3);
                    setTituloRestaurante(data["data"]["restaurantById"]["object"]["name"]);
                    setDescripcionRestaurante(data["data"]["restaurantById"]["object"]["description"]);
                    setMenuRestaurante(data["data"]["restaurantById"]["object"]["menuLetters"]);
                    setOpenModalRestaurantes(false);
                } else {
                    setCuerpoModalMensajes({
                        ...cuerpoModalMensajes,
                        tituloModal: "informacion",
                        textoModal: data["data"]["restaurantById"]["errors"][0]["messages"][0],
                    });
                    setOpenModalMensajes(true);
                    setOpenModalRestaurantes(false);
                }
            })
            .finally(() => {
                setOpenLoader(false);
            });
    };

    const handleClickAceptarHora = () => {
        setOpenModalHora(false);
    };

    const limpiarForm = () => {
        setFechaReservacion(new Date());
        setHoraReservacion(new Date());
        setInputPersonas(1);
    };

    const validacion_annadir = () => {
        let fecha = fechaReservacion;
        fecha = setHours(fecha, getHours(horaReservacion));
        fecha = setMinutes(fecha, getMinutes(horaReservacion));
        if (fecha - new Date() < 3600000) {
            return false;
        }
        return true;
    };

    const validacion_annadir2 = () => {
        let diasValidos = Object.keys(rangoHorario);
        let dia_semana = "";
        let resultado1 = false;
        if (isMonday(fechaReservacion)) {
            dia_semana = "Lunes";
            if (diasValidos.indexOf("Lunes") === -1) {
                resultado1 = true;
            }
        } else if (isTuesday(fechaReservacion)) {
            dia_semana = "Martes";
            if (diasValidos.indexOf("Martes") === -1) {
                resultado1 = true;
            }
        } else if (isWednesday(fechaReservacion)) {
            dia_semana = "Miércoles";
            if (diasValidos.indexOf("Miércoles") === -1) {
                resultado1 = true;
            }
        } else if (isThursday(fechaReservacion)) {
            dia_semana = "Jueves";
            if (diasValidos.indexOf("Jueves") === -1) {
                resultado1 = true;
            }
        } else if (isFriday(fechaReservacion)) {
            dia_semana = "Viernes";
            if (diasValidos.indexOf("Viernes") === -1) {
                resultado1 = true;
            }
        } else if (isSaturday(fechaReservacion)) {
            dia_semana = "Sábado";
            if (diasValidos.indexOf("Sábado") === -1) {
                resultado1 = true;
            }
        } else if (isSunday(fechaReservacion)) {
            dia_semana = "Domingo";
            if (diasValidos.indexOf("Domingo") === -1) {
                resultado1 = true;
            }
        }

        if (resultado1) {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_restaurante_uno" />,
            });
            setOpenModalMensajes(true);
            return false;
        }

        let fecha = rangoHorario[dia_semana].inicio;
        fecha = setHours(fecha, getHours(horaReservacion));
        fecha = setMinutes(fecha, getMinutes(horaReservacion));

        if (rangoHorario[dia_semana].final.getMonth() > rangoHorario[dia_semana].inicio.getMonth() || (rangoHorario[dia_semana].final.getMonth() === rangoHorario[dia_semana].inicio.getMonth() && rangoHorario[dia_semana].final.getDate() > rangoHorario[dia_semana].inicio.getDate())) {
            if (fechaReservacion.getDate() !== rangoHorario[dia_semana].inicio.getDate() || fechaReservacion.getMonth() !== rangoHorario[dia_semana].inicio.getMonth()) {
                if (horaReservacion.getHours() < rangoHorario[dia_semana].final.getHours()) {
                    fecha = addDays(fecha, 1);
                }
            }
        }

        if (isAfter(fecha, rangoHorario[dia_semana].inicio) && isBefore(fecha, rangoHorario[dia_semana].final)) {
        } else {
            if (!isEqual(fecha, rangoHorario[dia_semana].inicio)) {
                setCuerpoModalMensajes({
                    ...cuerpoModalMensajes,
                    tituloModal: "informacion",
                    textoModal: <FormattedMessage id="validacion_restaurante_uno" />,
                });
                setOpenModalMensajes(true);
                return false;
            }
        }
        return true;
    };

    const handleClickCartaMenu = () => {
        if (menuRestaurante.length === 0) {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="lo_sentimos_carta_menu" />,
            });
            setOpenModalMensajes(true);
        } else {
            history.push("/restaurantes/menu/" + tituloRestaurante);
        }
    };

    const handleClickReservarRestaurante = () => {
        if (selector.user.accessToken && selector.user.accessToken !== "") {
            if (!validacion_annadir()) {
                setCuerpoModalMensajes({
                    ...cuerpoModalMensajes,
                    tituloModal: "informacion",
                    textoModal: <FormattedMessage id="validacion_restaurante_dos" />,
                });
                setOpenModalMensajes(true);
            } else if (validacion_annadir2()) {
                let reservaRestaurante = `mutation ReservarRestaurante($input : RestaurantReservationInput!){
                    reserveRestaurant(input:$input){
                        status,
                        errors{
                            messages,
                            field
                        },
                        reservation{
                            id,
                            status,
                            reasonToDeny,
                        }
                    }
                }`;

                setOpenLoader(true);
                fetch(`${SERVER_URL}`, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + selector.user.accessToken,
                        "Content-Type": "application/json",
                        Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                        Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                    },
                    body: JSON.stringify({
                        operationName: "ReservarRestaurante",
                        query: reservaRestaurante,
                        variables: {
                            input: {
                                personsQty: inputPersonas,
                                datetime: fns_format(fechaReservacion, "yyyy-MM-dd") + "T" + fns_format(horaReservacion, "HH:mm:ss"),
                                restaurant: indexRestaurante.index,
                            },
                        },
                    }),
                })
                    .then((r) => r.json())
                    .then((data) => {
                        if (data["data"]["reserveRestaurant"]["status"] === 200 && data["data"]["reserveRestaurant"] != null) {
                            if (data["data"]["reserveRestaurant"]["reservation"]["status"] === "CONFIRMED") {
                                setIdReservacion(data["data"]["reserveRestaurant"]["reservation"]["id"]);
                                setOpenNotificacionPago(true);
                                setEstadoReseva(true);
                            } else {
                                setOpenNotificacionPago(true);
                                setEstadoReseva(false);
                            }
                            limpiarForm();
                        } else {
                            setCuerpoModalMensajes({
                                ...cuerpoModalMensajes,
                                tituloModal: "informacion",
                                textoModal: data["data"]["reserveRestaurant"]["errors"][0]["messages"][0],
                            });
                            setOpenModalMensajes(true);
                            limpiarForm();
                        }
                    })
                    .finally(() => {
                        setOpenLoader(false);
                    });
            }
        } else dispatch({ type: "DRAWER_OPERATION_LOGIN", status: true });
    };

    //-------------------------------------------------------------------------------
    //----------------------------VISTA----------------------------------------------
    //-------------------------------------------------------------------------------
    useEffect(() => {
        cargarRestaurantes();
        window.addEventListener("resize", function () {
            setAncho(window.screen.width);
        });
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 100);
        // setTimeout(() => {
        //     formReservarRestaurante.current.scrollIntoView();
        // }, 1000);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {/*-------------------------------------*/}
            {/*---------------HEADER----------------*/}
            {/*-------------------------------------*/}
            {openLoader ? <Loader /> : ""}
            <Grid container spacing={0}>
                <Grid
                    item
                    xs={12}
                    container
                    justify="center"
                    className={classes.paperContainer}
                    style={{
                        backgroundImage: `url(${imagenPrincipal})`,
                        height: window.innerHeight,
                    }}
                >
                    <Grid item xs={12} className={classes.gridItem}>
                        <HeaderBar page={textoSubtitulo} namePage={textoTitulo} rootPath={rootPath} childPath="" />
                    </Grid>
                </Grid>
            </Grid>

            <Grid ref={formReservarRestaurante} item container xs={12} justify="center" alignItems="center" className={classes.gridItem} style={{ backgroundColor: "#182C20", marginTop: -120 }}>
                {/*-------------------------------------*/}
                {/*---------------CARD HEADER-----------*/}
                {/*-------------------------------------*/}
                <Grid item container xs={1} sm={3} />
                <Grid item container xs={10} sm={6} style={{ backgroundColor: "#A68A30", padding: ancho > 600 ? "0 120px" : "0 20px", marginBottom: selectRestaurantes.length === 0 ? 100 : 0 }}>
                    {/* //? work here areyesarean */}
                    {isPendingRestaurantsQuery ? 
                    (   <LoaderCircle/>) : selectRestaurantes.length > 0  ? (
                        <React.Fragment>
                            <Grid item xs={12} style={{ textAlign: "center" }}>
                                <div className={classes.typographyTextoReservaAhora}>{textoCardHeaderRestaurantes}</div>
                            </Grid>
                            <Grid item container xs={12} justify="center" alignItems="center" style={{ marginTop: 20 }}>
                                <Grid item xs={12} sm={12} md={8} lg={8} xl={6}>
                                    <ThemeProvider theme={theme2}>
                                        <FormControl variant="outlined" style={{ width: "100%" }}>
                                            <InputLabel htmlFor="seleccione" style={{ color: "#DFDFDF" }}>
                                                <FormattedMessage id="seleccione" />
                                            </InputLabel>
                                            <OutlinedInput
                                                id="restaurantes"
                                                label={<FormattedMessage id="seleccione" />}
                                                value={indexRestaurante.nombre}
                                                variant="outlined"
                                                fullWidth
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle"
                                                            onClick={() => {
                                                                setOpenModalRestaurantes(true);
                                                            }}
                                                            edge="end"
                                                        >
                                                            {<ExpandMoreIcon style={{ color: "#f3f3f3" }} />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                                inputProps={{
                                                    style: {
                                                        textAlign: "left",
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    </ThemeProvider>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
                                <div className={classes.tituloReservaSeleccionada}>{tituloRestaurante}</div>
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
                                <div className={classes.tituloReservaSeleccionada2}>{textoHorario}</div>
                            </Grid>

                            <Grid item xs={12} container justify="center" alignItems="center" style={{ textAlign: "center", marginTop: 20 }}>
                                {listHorario.map((item, index) => (
                                    <div className={classes.horarios} key={index}>
                                        {item["day"]}:{" "}
                                        <i style={{ color: "#182C20" }} key={index}>
                                            {" " + item["open"]} - {item["close"]}
                                        </i>
                                    </div>
                                ))}
                            </Grid>

                            <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
                                <div className={classes.textoCardHeader}>{descripcionRestaurante}</div>
                            </Grid>
                            <Grid item container direction="row" justify="center" alignItems="center" xs={12} /*sm={6}*/ style={{ marginTop: 20 }}>
                                <img alt="" src={require("../../static/Íconos/Carta menú dorado.svg")} />
                                <Typography className={classes.textCartaMenu} onClick={handleClickCartaMenu}>
                                    {textoCartaMenu}
                                </Typography>
                            </Grid>
                            {/* <Grid item container direction="row" justify="center" alignItems="center" xs={12} sm={6} style={{ marginTop: 20 }}>
                                <img alt="" src={require("../../static/Íconos/Mapa dorado.svg")} />
                                <Typography className={classes.textCartaMenu}>{textoUbicacionHotel}</Typography>
                            </Grid> */}
                        </React.Fragment>
                    ) : (
                        <Grid item xs={12} style={{ textAlign: "center", marginTop: 100, marginBottom: 100 }}>
                            <div className={classes.tituloReservaSeleccionada}>{intl.formatMessage({ id: "lo_sentimos_restaurantes" }).toString()}</div>
                        </Grid>
                    )}
                </Grid>
                <Grid item container xs={1} sm={3} />
                {/*---------------Carrusel-----------*/}
                {selectRestaurantes.length > 0 && (
                    <React.Fragment>
                        <Grid item container direction="column" xs={1} sm={3} justify="center" alignItems="center">
                            {ancho > 600 && (
                                <img
                                    alt=""
                                    src={imagenCarrusel2}
                                    style={{
                                        height: 350,
                                        width: 300,
                                        marginRight: ancho > 600 && ancho < 1000 ? "-20%" : ancho > 1000 && ancho < 1400 ? "-40%" : ancho > 1400 && ancho < 1800 ? "-40%" : ancho > 1800 && ancho < 2200 ? "-60%" : "-80%",
                                        zIndex: 50,
                                    }}
                                />
                            )}
                        </Grid>
                        <Grid item xs={10} sm={6} style={{ backgroundColor: "#A68A30", padding: ancho > 600 ? "0 120px" : "0 20px" }}>
                            <Grid item xs={12} container direction="column" justify="center" alignItems="center" style={{ marginTop: 20, marginBottom: 40 }}>
                                <Carousel style={{ width: "100%" }} showIndicators={false} showThumbs={false} showStatus={false} autoPlay infiniteLoop showArrows={false} transitionTime={500} interval={2000}>
                                    <div>
                                        <img alt="" src={imagenCarrusel1} style={{ height: ancho > 600 ? 400 : 300, width: "100%" }} />
                                    </div>
                                </Carousel>
                            </Grid>
                        </Grid>
                        <Grid item container direction="column" xs={1} sm={3} justify="center" alignItems="center">
                            {ancho > 600 && (
                                <img
                                    alt=""
                                    src={imagenCarrusel3}
                                    style={{
                                        height: 350,
                                        width: 300,
                                        marginLeft: ancho > 600 && ancho < 1000 ? "-20%" : ancho > 1000 && ancho < 1400 ? "-40%" : ancho > 1400 && ancho < 1800 ? "-40%" : ancho > 1800 && ancho < 2200 ? "-60%" : "-80%",
                                        zIndex: 50,
                                    }}
                                />
                            )}
                        </Grid>
                        {/*-------------------------------------*/}
                        {/*---------------FORMULARIO------------*/}
                        {/*-------------------------------------*/}
                        <Grid item container xs={1} sm={3} />
                        <Grid item container xs={10} sm={6}>
                            {indexRestaurante.reservable && (
                                <React.Fragment>
                                    <Grid item xs={12} style={{ textAlign: "center" }}>
                                        <div className={classes.typographyTextoReservaAhoraForm}>{textoReservaAhora}</div>
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
                                        <div className={classes.tituloReservaSeleccionadaForm}>{tituloRestaurante}</div>
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
                                        <div className={classes.textoCardHeaderForm}>{textoDatosReserva}</div>
                                    </Grid>
                                    <Grid item xs={12} sm={4} style={{ marginTop: 20 }}>
                                        <ThemeProvider theme={theme}>
                                            <FormControl variant="outlined" size="small" fullWidth>
                                                <InputLabel htmlFor="fecha_disfrute" style={{ color: "#DFDFDF" }}>
                                                    <FormattedMessage id="fecha_disfrute" />
                                                </InputLabel>
                                                <OutlinedInput
                                                    label={<FormattedMessage id="fecha_disfrute" />}
                                                    value={fns_format(fechaReservacion, "dd/MM/yyyy")}
                                                    variant="outlined"
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                aria-label="toggle"
                                                                onClick={() => {
                                                                    setOpenModalFecha(true);
                                                                }}
                                                                edge="end"
                                                            >
                                                                <DateRangeIcon className={classes.iconTextField} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    inputProps={{ style: { textAlign: "left" } }}
                                                />
                                            </FormControl>
                                        </ThemeProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={4} style={{ marginTop: 20, paddingLeft: ancho > 600 ? 20 : 0 }}>
                                        <ThemeProvider theme={theme}>
                                            <FormControl variant="outlined" size="small" fullWidth>
                                                <InputLabel htmlFor="hora_disfrute" style={{ color: "#DFDFDF" }}>
                                                    <FormattedMessage id="hora_disfrute" />
                                                </InputLabel>
                                                <OutlinedInput
                                                    label={<FormattedMessage id="hora_disfrute" />}
                                                    value={fns_format(horaReservacion, "hh:mm aaaa")}
                                                    variant="outlined"
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                aria-label="toggle"
                                                                onClick={() => {
                                                                    setOpenModalHora(true);
                                                                }}
                                                                edge="end"
                                                            >
                                                                <QueryBuilderIcon className={classes.iconTextField} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    inputProps={{ style: { textAlign: "left" } }}
                                                />
                                            </FormControl>
                                        </ThemeProvider>
                                    </Grid>
                                    <Grid item xs={6} sm={4} style={{ marginTop: 20, paddingLeft: ancho > 600 ? 20 : 0 }}>
                                        <ThemeProvider theme={theme}>
                                            <FormControl variant="outlined" size="small" fullWidth>
                                                <InputLabel htmlFor="personas" style={{ color: "#DFDFDF" }}>
                                                    <FormattedMessage id="personas" />
                                                </InputLabel>
                                                <OutlinedInput
                                                    label="Personas"
                                                    value={inputPersonas}
                                                    inputProps={{ style: { textAlign: "center" } }}
                                                    startAdornment={
                                                        <InputAdornment position="start">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setInputPersonas(inputPersonas - 1);
                                                                }}
                                                                disabled={inputPersonas > 1 ? false : true}
                                                            >
                                                                <RemoveCircleIcon className={inputPersonas > 1 ? classes.iconTextField : classes.iconTextFieldDisabled} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setInputPersonas(inputPersonas + 1);
                                                                }}
                                                                disabled={inputPersonas > 9 ? true : false}
                                                            >
                                                                <AddCircleIcon className={inputPersonas > 9 ? classes.iconTextFieldDisabled : classes.iconTextField} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </ThemeProvider>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginTop: 40 }}>
                                        <Divider className={classes.divider} />
                                    </Grid>
                                    <Grid item xs={12} style={{ marginTop: 20 }}>
                                        <Typography className={classes.numeroDataFormReserva}>{tituloRestaurante}</Typography>
                                        <Typography className={classes.etiquetaDataFormReserva}>
                                            <b>{textoFechaDisfrute}</b>: {fns_format(fechaReservacion, "dd/MM/yyyy")}
                                        </Typography>

                                        <Typography className={classes.etiquetaDataFormReserva}>
                                            <b>{textoHoraDisfrute}</b>: {fns_format(horaReservacion, "hh:mm aaaa")}
                                        </Typography>
                                        <Typography className={classes.etiquetaDataFormReserva}>
                                            <b>{textoPersonas}</b>: {inputPersonas}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginTop: 20 }}>
                                        <Divider className={classes.divider} />
                                    </Grid>
                                    <Grid item container justify="center" alignItems="center" xs={12} style={{ marginTop: 20, marginBottom: 80 }}>
                                        <Button variant="contained" onClick={handleClickReservarRestaurante} className={classes.buttons}>
                                            <FormattedMessage id="reservar" />
                                        </Button>
                                    </Grid>
                                </React.Fragment>
                            )}
                        </Grid>
                        <Grid item container xs={1} sm={3} />
                    </React.Fragment>
                )}
            </Grid>

            {/* inicio footer */}
            <Footer />
            {/* fin footer */}

            {/* Dialogo Mensaje */}
            <ModalMensajes openModal={openModalMensajes} setOpenModal={setOpenModalMensajes} cuerpoModal={cuerpoModalMensajes} />

            {/* dialogo fecha */}
            <Dialog
                maxWidth="xs"
                open={openModalFecha}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenModalFecha(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="max-width-dialog-title"
                fullWidth={ancho < 576 ? false : true}
                fullScreen={ancho < 576 ? true : false}
            >
                <DialogTitle className={classes.modalContent}>
                    <Grid item container xs={12}>
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <img
                                alt=""
                                src={require("../../static/Identificador/Logo hotel dorado.svg")}
                                style={{
                                    height: "100px",
                                    width: "100px",
                                    marginBottom: 10,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="flex-start">
                            <IconButton
                                onClick={() => {
                                    setOpenModalFecha(false);
                                }}
                                className={classes.iconClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <Typography className={classes.textoHeader} align="center">
                                <FormattedMessage id="seleccionar_fecha_disfrute" />
                            </Typography>
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="center" />
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <Divider className={classes.divider2} />
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="center" />
                    </Grid>
                </DialogTitle>
                <DialogContent className={classes.modalContent}>
                    <Grid item container xs={11} justify="center" alignItems="center">
                        <Calendar
                            onChange={handleChangeFechaReserva}
                            date={fechaReservacion}
                            minDate={new Date()}
                            maxDate={addMonths(new Date(), 1)}
                            locale={date_range_location}
                            color="#A68A30"
                            disabledDates={fechaInvalidas}
                            className={ancho > 400 ? classes.inputCalendar : classes.inputCalendar2}
                        />
                    </Grid>
                    <Grid item container xs={1} justify="center" alignItems="center" />
                    <DialogActions />
                </DialogContent>
            </Dialog>

            {/* dialogo hora */}
            <Dialog
                maxWidth="xs"
                open={openModalHora}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenModalHora(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="max-width-dialog-title"
                fullWidth={ancho < 576 ? false : true}
                fullScreen={ancho < 1370 ? true : false}
            >
                <DialogTitle className={classes.modalContent}>
                    <Grid item container xs={12}>
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <img
                                alt=""
                                src={require("../../static/Identificador/Logo hotel dorado.svg")}
                                style={{
                                    height: "100px",
                                    width: "100px",
                                    marginBottom: 10,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="flex-start">
                            <IconButton
                                onClick={() => {
                                    setOpenModalHora(false);
                                }}
                                className={classes.iconClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <Typography className={classes.textoHeader} align="center">
                                <FormattedMessage id="seleccionar_hora_disfrute" />
                            </Typography>
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="center" />
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <Divider className={classes.divider2} />
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="center" />
                    </Grid>
                </DialogTitle>
                <DialogContent className={classes.modalContent}>
                    <Grid item container xs={11} justify="center" alignItems="center">
                        <TimePicker variant="static" openTo="hours" value={horaReservacion} onChange={handleChangeHoraReserva} />
                    </Grid>
                    <Grid item container xs={1} justify="center" alignItems="center" />
                </DialogContent>
                <DialogActions className={classes.modalActions}>
                    <Grid item container xs={11} justify="center" alignItems="center">
                        <Button
                            variant="contained"
                            onClick={() => {
                                handleClickAceptarHora();
                            }}
                            className={classes.buttons}
                        >
                            <FormattedMessage id="aceptar" />
                        </Button>
                    </Grid>
                    <Grid item container xs={1} justify="center" alignItems="center" />
                </DialogActions>
            </Dialog>

            {/* dialogo seleccionar restaurante */}
            <Dialog
                maxWidth="sm"
                open={openModalRestaurantes}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenModalRestaurantes(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="max-width-dialog-title"
                fullWidth
            >
                <DialogTitle id="max-width-dialog-title" className={classes.modalContent}>
                    <Grid item container xs={12}>
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <img
                                alt=""
                                src={require("../../static/Identificador/Logo hotel dorado.svg")}
                                style={{
                                    height: "100px",
                                    width: "100px",
                                    marginBottom: 10,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="flex-start">
                            <IconButton
                                onClick={() => {
                                    setOpenModalRestaurantes(false);
                                }}
                                className={classes.iconClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <Typography className={classes.textoHeader}>
                                <FormattedMessage id="seleccione_tipo_restaurante" />
                            </Typography>
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="center" />
                        <Grid item xs={11} container justify="center" alignItems="center">
                            <Divider className={classes.divider} />
                        </Grid>
                        <Grid item xs={1} container justify="center" alignItems="center" />
                    </Grid>
                </DialogTitle>
                <DialogContent className={classes.modalContent}>
                    <Grid item container xs={11} justify="center" alignItems="center">
                        {selectRestaurantes.length > 0 ? (
                            <RadioGroup aria-label="restaurantes" name="restaurantes" value={indexRestaurante.index}>
                                {selectRestaurantes.map((item, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={item.id}
                                        control={
                                            <Radio
                                                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                                                checkedIcon={<CheckCircleOutlineIcon fontSize="small" />}
                                                name="checkedI"
                                                style={{
                                                    color: "#929292",
                                                }}
                                                onClick={() => {
                                                    handleChangeRestaurantes(item.id);
                                                }}
                                            />
                                        }
                                        style={{
                                            borderBottomWidth: 2,
                                            borderBottomStyle: "solid",
                                            borderBottomColor: "#929292",
                                        }}
                                        label={
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <Typography style={{ color: "#929292", marginLeft: 10 }}>{item.name}</Typography>
                                            </div>
                                        }
                                    />
                                ))}
                            </RadioGroup>
                        ) : (
                            <React.Fragment />
                        )}
                    </Grid>
                    <Grid item xs={1} container justify="center" alignItems="center" />
                </DialogContent>
                <DialogActions className={classes.modalActions} />
            </Dialog>

            {/*Dialogo notificacion pago*/}
            <Dialog
                maxWidth="sm"
                open={openNotificacionPago}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenNotificacionPago(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="max-width-dialog-title"
                style={{ backgroundColor: "#182c20" }}
                fullWidth
            >
                <DialogTitle id="max-width-dialog-title" className={classes.modalContent}>
                    <Grid item container xs={12}>
                        <Grid item xs={12} container justify="center" alignItems="center">
                            <img
                                alt=""
                                src={require("../../static/Identificador/Logo hotel dorado.svg")}
                                style={{
                                    height: "100px",
                                    width: "100px",
                                    marginBottom: 10,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} container justify="center" alignItems="center">
                            <Typography className={classes.textoHeader}>
                                <FormattedMessage id={!estadoReseva ? "informacion_titulo_pago_error" : "informacion_titulo_pago_exito"} />
                            </Typography>
                        </Grid>
                        <Grid item xs={12} container justify="center" alignItems="center">
                            <Divider className={classes.divider} style={{ width: ancho < 576 ? "15%" : "7%" }} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className={classes.modalContent}>
                    <Grid item container xs={12} justify="center" alignItems="center">
                        <Grid item xs={12} container justify="center" alignItems="center" style={{ marginBottom: !estadoReseva ? 15 : 5 }}>
                            <Typography align="center" className={classes.texto2}>
                                <FormattedMessage id={!estadoReseva ? "informacion_texto_notificacion_pago_error2" : "informacion_texto_notificacion_pago_exito2"} />
                            </Typography>
                        </Grid>
                        {estadoReseva && (
                            <Grid item xs={12} container justify="center" alignItems="center" style={{ marginBottom: 15 }}>
                                <Typography align="center" className={classes.texto3}>
                                    No. {idReservacion}. <FormattedMessage id="gracias_por_elegirnos" />
                                </Typography>
                            </Grid>
                        )}
                        {estadoReseva && (
                            <React.Fragment>
                                <Grid item xs={12} container justify="center" alignItems="center">
                                    <Typography align="center" className={classes.textoHeader} style={{ marginBottom: 15, marginTop: 15 }}>
                                        <FormattedMessage id="politica_cancelacion_titulo" />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} container justify="center" alignItems="center" style={{ marginBottom: 15 }}>
                                    <Typography align="center" className={classes.texto2}>
                                        <FormattedMessage id="politica_cancelacion_texto" />
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalActions}>
                    <Grid item container xs={12} justify="center" alignItems="center">
                        <Button
                            variant="contained"
                            onClick={() => {
                                setOpenNotificacionPago(false);
                            }}
                            className={classes.buttons}
                        >
                            <FormattedMessage id="aceptar" />
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    );
}
